import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import type { Disaster } from '@/types/api/operation/disaster/disaster'
import { useDisasterApi } from '@/api/operation/disaster/queryDisasters'
import MiiaFwConfig from '@/configs/config'
import { GlobalError } from '@/utils/globalError/GlobalError'
import { ERROR_CODES } from '@/constants/error/errorCode'

export const useDisasterStore = defineStore(
  'disasterStore',
  () => {
    const disasters = ref<Disaster[]>([])
    const { query: getDisasters } = useDisasterApi()

    const fetchAndSetDisasters = async (govCode: string) => {
      try {
        const queryRes = await getDisasters({ system: MiiaFwConfig.config.sysId, govCode })
        disasters.value = queryRes
      } catch (e) {
        if (e instanceof GlobalError) {
          throw e.addErrorCodeFirst(ERROR_CODES._811101_QUERY_DISASTER_ERROR)
        }
        throw new GlobalError(ERROR_CODES._811101_QUERY_DISASTER_ERROR, {
          message: String(e)
        })
      }
    }

    const disasterId = computed(() => disasters.value.find(d => d.isEnabled)?.disasterId)
    const disasterName = computed(() => disasters.value.find(d => d.isEnabled)?.disasterName)

    const reset = () => {
      disasters.value.splice(0)
    }

    return {
      disasters,
      disasterId,
      disasterName,
      fetchAndSetDisasters,
      reset
    }
  },
  {
    persist: true // 永続化の設定を追加
  }
)
